const Footer = () => {
    return (
        <div className='footer'>
            <h1>Important Links</h1>
            <div className='atag'>
                <a href='#'>Contact us</a>
                <a href='#'>Home</a>
                <a href='#'>Customer Feedback</a>
                <a href='#'>About</a>
            </div>
            <span className='allrights'>© All right reserved</span>
        </div>
    )
}
export default Footer
